/**
 * CCMS SDK configuration for the Resource Centre.
 *
 * Mirrors the ccms_v2 wiring exactly:
 *
 *   browser → SDK fetch (cross-origin) → Express proxy on :5181
 *           → microservices (or production via BACKEND_BASE_URL)
 *
 * The SDK's `baseUrl` points DIRECTLY at the Express proxy, so requests bypass
 * the Vite dev server entirely (vite still serves the SPA at :5180). This is
 * the same pattern ccms_v2 uses with `VITE_CCMS_BASE_URL=http://localhost:5174`.
 */
// Treat empty string the same as missing — an accidentally-empty build arg
// (Dockerfile ARG unset → `echo VITE_CCMS_BASE_URL=` writes an empty value)
// would otherwise produce same-origin URLs WITHOUT the `/api` prefix, which
// bypasses the console-nginx → proxy chain and 405s on POST to /users/...
// when the resources.actschurch.co.za host has no /users/* rule.
export const CCMS_BASE_URL =
  import.meta.env.VITE_CCMS_BASE_URL
    ? import.meta.env.VITE_CCMS_BASE_URL
    : 'http://localhost:5181';

export const CCMS_SERVICE_PATH_RESOURCES =
  import.meta.env.VITE_CCMS_SERVICE_PATH_RESOURCES ?? 'resources';
export const CCMS_SERVICE_PATH_AI =
  import.meta.env.VITE_CCMS_SERVICE_PATH_AI ?? 'ai-management';
